/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import React from "react";

type AdminSalesDashboardSecondaryButtonProps = {
  text: string;
  onClick?: () => void;
  disabled?: boolean;
};

export const AdminSalesDashboardSecondaryButton: React.FC<
  AdminSalesDashboardSecondaryButtonProps
> = ({ disabled, onClick, text }) => {
  return (
    <button
      css={styles.button}
      disabled={disabled}
      onClick={onClick}
      type="button"
    >
      {text}
    </button>
  );
};

const styles = {
  button: css`
    display: inline-flex;
    align-items: center;
    min-height: 38px;
    padding: 9px 16px;
    color: #ffffff;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.4px;
    background: #22313f;
    border: 1px solid #2e3d4c;
    border-radius: 8px;
    cursor: pointer;
    &:not(:disabled):hover {
      border-color: #00c2ae;
    }
    &:disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
    &:focus-visible {
      outline: 2px solid #00c2ae;
      outline-offset: 2px;
    }
  `,
};
